export class ArrowBuilder {
    constructor() {
        this.setSceneIndex = (sceneIndex) => {
            this.sceneIndex = sceneIndex;
            return this;
        };
        this.setTourScene = (tourSceneGuid) => {
            this.tourSceneGuid = tourSceneGuid;
            return this;
        };
        this.setFov = (fov) => {
            this.fov = fov;
            return this;
        };
        this.sceneIndex = undefined;
        this.tourSceneGuid = undefined;
        this.fov = undefined;
    }
}
